import React from 'react';

import { Subsite } from 'api/website';
import Box from 'components/Box';
import { PrimaryButtonLink } from 'components/Button';
import Icon from 'components/Icon/Icon';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const StaffTools = ({
  content,
}: {
  content: {
    id: string;
    locale: string;
    subsite: Subsite;
    type: 'PAGE' | 'POST';
  };
}) => (
  <Box
    p="0 !important"
    component={PrimaryButtonLink}
    href={`/cms/subsite/${content.subsite.id}/${content.type.toLowerCase()}s/${
      content.id
    }/edit`}
    data-qa-id="edit-button"
    aria-label={getText('Edit')}
    boxShadow="0 2px 3px rgba(0,0,0,0.25)"
  >
    <Box
      width={40}
      height={40}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Icon name="edit" width={24} fill="currentColor" />
    </Box>
  </Box>
);

// eslint-disable-next-line import/no-default-export
export default StaffTools;
